import {Component, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from '@angular/forms';
import {ModalDirective} from "ng2-bootstrap";
import {HttpService} from '../../../core/services/http.service';
import {environment} from "../../../../environments/environment";

export class MailingModel {
  id: number;
  nazwa: string = '';
  title_pl: string = '';
  title_en: string = '';
}

@Component({
  selector: 'mailing-modal',
  templateUrl: './mailing.modal.component.html',
  styleUrls: [ './mailing.modal.component.scss' ]
})
export class MailingModalComponent {
  public mailing: MailingModel = new MailingModel();

  @ViewChild('mailingModal') public mailingModal: ModalDirective;

  @Output()
  refreshList = new EventEmitter<boolean>();

  @Input()
  setModalMode;

  nazwa: FormControl = new FormControl("",Validators.required);
  title_pl: FormControl = new FormControl("",Validators.required);
  title_en: FormControl = new FormControl("",Validators.required);

  mailingForm: FormGroup;

  errors: any;

  constructor( //private api: ApiService,
              private fb: FormBuilder,
              private http: HttpService
  ) {

    this.mailingForm = fb.group({
      'id': [null],
      'nazwa': this.nazwa,
      'title_pl': this.title_pl,
      'title_en': this.title_en
    });

  }

  buildForm() {
    this.mailingForm.reset();
    this.mailingForm.patchValue(this.mailing);
  }

  private backendUrl = environment.backendUrl;

  show(mailing) {
    this.mailing = mailing ? mailing : new MailingModel();

    this.buildForm();

    this.mailingModal.show(); 
  }

  onSubmit(event) {
    if (!this.mailingForm.valid) {
      return;
    }

    this.mailing = this.mailingForm.value;

    if(this.mailing.id) {
      this.http.put(this.backendUrl+'api/mailing/'+this.mailing.id, this.mailingForm.value )
           .subscribe(
                data => {
                  this.errors = [];
                  this.refreshList.emit();    
                  this.mailingModal.hide(); 
                  this.mailingForm.reset()
                },
                error => {
                  this.errors = error.json().errors;
                 }
           );
    }
    else {
      this.http.post(this.backendUrl+'api/mailing', this.mailingForm.value )
           .subscribe(
                data => {
                  this.errors = [];
                  this.refreshList.emit();    
                  this.mailingModal.hide(); 
                  this.mailingForm.reset()
                },
                error => {
                  this.errors = error.json().errors;
                 }
           );
    }

  } 

}





// WEBPACK FOOTER //
// /code/frontend/src/app/main/mailings/modals/mailing.modal.component.ts